import {Exclude, Type} from 'class-transformer';

import {TranslatedText} from 'shared/models/translated-text';
import {AnswerOption} from './answer-option';
import {KeyPoint} from './keypoint';
import {QuestionType} from './question-type';

export abstract class AbstractSliderQuestionType implements QuestionType {
  public name: string = 'slider';
  @Exclude({toPlainOnly: true})
  public prettyName: string = 'Slider';
  @Exclude({toPlainOnly: true})
  public icon: string = 'slider';
  @Type(() => TranslatedText)
  public minText: TranslatedText;
  @Type(() => TranslatedText)
  public maxText: TranslatedText;
  public keyPoints: Array<KeyPoint> = [];
  public isSnapping: boolean = false;
  public title: TranslatedText;

  constructor(hasSliderTitle: boolean) {
    if (hasSliderTitle) {
      this.title = TranslatedText.createEmptyInstance();
    }
    this.minText = TranslatedText.createEmptyInstance();
    this.maxText = TranslatedText.createEmptyInstance();
  }

  public getAnswerOptions(): Array<AnswerOption> {
    return this.keyPoints.map((keyPoint, index) => {
      const title: TranslatedText = keyPoint.title ? keyPoint.title : {
        de: '<kein Titel>',
        en: '<no title>',
      };

      return {
        label: `${title.de} (${keyPoint.value}%)`,
        value: index,
      };
    });
  }

  public addKeyPoint(): KeyPoint {
    const keyPoint: KeyPoint = {
      title: TranslatedText.createEmptyInstance(),
      value: 0,
    };

    this.keyPoints.push(keyPoint);

    return keyPoint;
  }

  public deleteKeyPoint(index: number): void {
    this.keyPoints.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/abstract-slider-question-type.ts